/* comparison.js – fixed-width scrolling (4 columns) + star fill */
document.addEventListener('DOMContentLoaded', () => {
  const wrap   = document.getElementById('scroll-wrap');
  const leftB  = document.querySelector('.scroll-btn.left');
  const rightB = document.querySelector('.scroll-btn.right');

  const COL_W = 260;            // must match .prod-col width
  const jump  = dir => {
    const maxLeft = wrap.scrollWidth - wrap.clientWidth;
    let target = wrap.scrollLeft + dir * COL_W;
    if (target < 0)       target = 0;
    if (target > maxLeft) target = maxLeft;
    wrap.scrollTo({ left: target, behavior:'smooth' });
  };

  leftB.onclick  = () => jump(-1);
  rightB.onclick = () => jump( 1);

  const updateArrows = () => {
    const maxLeft = wrap.scrollWidth - wrap.clientWidth;
    leftB .classList.toggle('disabled', wrap.scrollLeft <= 0);
    rightB.classList.toggle('disabled', wrap.scrollLeft >= maxLeft - 1);
  };
  updateArrows();
  wrap.addEventListener('scroll', updateArrows);
  window.addEventListener('resize', updateArrows);

  /* star bar fill */
  document.querySelectorAll('.stars').forEach(el => {
    const pct = (parseFloat(el.dataset.score || '0') / 5) * 100;
    el.innerHTML =
      '<span class="star-back">★★★★★</span>' +
      '<span class="star-front" style="width:'+pct+'%;">★★★★★</span>';
  });
});
